// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay__overlay--3c5w4","active":"Overlay__active--1xnV_"};